import Form     from 'scripts/poppet/form';
import template from 'templates/unitAliasForm.jst.html';

const selectors = {
	inputAlias: '[data-input=alias-alias]',
};

/**
 * defa.views.UnitAliasForm
 * A view for changing a units alias.
 * @version 1.2.0
 */
const UnitAliasForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		alias: selectors.inputAlias,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let alias = this.ui.alias.val().trim();
		this.model.saveAlias( {
			alias: alias,
		} );
	},
	
} );


export default UnitAliasForm;
